import React from "react";

/**
 * Iconițe SVG personalizate pentru echipamentul PSA — desenate să semene cu echipamentul
 * industrial real folosit de ConVic (Vollmaske 3M, furtun respirator cu cuplaje, curea
 * cu regulator 3M Versaflo etc.) în loc de emoji-uri generice care nu se potriveau.
 */

const Mask = ({ size = 24, color = "currentColor" }) => (
  <svg viewBox="0 0 32 32" width={size} height={size} fill="none" stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-label="Vollmaske">
    {/* vizor frontal mare (forma rotunjită a Vollmaske) */}
    <path d="M6 11c0-2.2 1.8-4 4-4h12c2.2 0 4 1.8 4 4v7c0 4.4-3.6 8-8 8h-4c-4.4 0-8-3.6-8-8v-7z" fill={color} fillOpacity="0.08"/>
    {/* curele de prindere */}
    <path d="M4 13l-2 1M28 13l2 1M4 18l-2 1M28 18l2 1"/>
    {/* cartuș filtru centru-jos */}
    <circle cx="16" cy="22" r="3.5" fill={color} fillOpacity="0.15"/>
    <circle cx="16" cy="22" r="1.2" fill={color}/>
  </svg>
);

const Hose = ({ size = 24, color = "currentColor" }) => (
  <svg viewBox="0 0 32 32" width={size} height={size} fill="none" stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-label="Furtun respirator">
    {/* furtun ondulat cu cuplaje la capete */}
    <path d="M5 9c3 0 3 4 6 4s3-4 6-4 3 4 6 4 3-4 6-4"/>
    <path d="M5 16c3 0 3 4 6 4s3-4 6-4 3 4 6 4 3-4 6-4"/>
    {/* cuplaj rapid stânga */}
    <circle cx="4" cy="23" r="2.5" fill={color} fillOpacity="0.2"/>
    <circle cx="4" cy="23" r="0.8" fill={color}/>
    {/* cuplaj rapid dreapta */}
    <rect x="25" y="20" width="5" height="6" rx="1" fill={color} fillOpacity="0.2"/>
    <line x1="27.5" y1="22" x2="27.5" y2="24"/>
  </svg>
);

const Belt = ({ size = 24, color = "currentColor" }) => (
  <svg viewBox="0 0 32 32" width={size} height={size} fill="none" stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-label="Curea cu regulator">
    {/* banda curelei (full width) */}
    <rect x="1" y="13" width="30" height="6" rx="1" fill={color} fillOpacity="0.1"/>
    {/* regulator central (caseta 3M) */}
    <rect x="11" y="9" width="10" height="14" rx="1.5" fill={color} fillOpacity="0.25"/>
    {/* buton/dial regulator */}
    <circle cx="16" cy="16" r="2" fill={color} fillOpacity="0.5"/>
    <circle cx="16" cy="16" r="0.7" fill={color}/>
    {/* clip-uri laterale */}
    <line x1="11" y1="12" x2="11" y2="20"/>
    <line x1="21" y1="12" x2="21" y2="20"/>
  </svg>
);

const Boots = ({ size = 24, color = "currentColor" }) => (
  <svg viewBox="0 0 32 32" width={size} height={size} fill="none" stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-label="Cizme">
    <path d="M11 5h6v15h7v5H8v-5l3-3V5z" fill={color} fillOpacity="0.15"/>
    <line x1="17" y1="20" x2="24" y2="20"/>
  </svg>
);

const Shirt = ({ size = 24, color = "currentColor" }) => (
  <svg viewBox="0 0 32 32" width={size} height={size} fill="none" stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-label="Tricou">
    <path d="M12 5l-7 4 2 5 3-1v14h12V13l3 1 2-5-7-4-4 3-4-3z" fill={color} fillOpacity="0.15"/>
  </svg>
);

const Hoodie = ({ size = 24, color = "currentColor" }) => (
  <svg viewBox="0 0 32 32" width={size} height={size} fill="none" stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-label="Hanorac">
    <path d="M11 7l-6 4 2 5 3-1v12h12V15l3 1 2-5-6-4c-1 4-9 4-10 0z" fill={color} fillOpacity="0.15"/>
    {/* glugă */}
    <path d="M13 5c0 2 6 2 6 0"/>
    {/* fermoar centru */}
    <line x1="16" y1="11" x2="16" y2="27"/>
  </svg>
);

const HikingBoots = ({ size = 24, color = "currentColor" }) => (
  <svg viewBox="0 0 32 32" width={size} height={size} fill="none" stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-label="Bocanci">
    <path d="M11 5h5v13h8c1.1 0 2 .9 2 2v5H7v-7l4-3V5z" fill={color} fillOpacity="0.18"/>
    {/* șireturi */}
    <line x1="11.5" y1="8" x2="15.5" y2="8"/>
    <line x1="11.5" y1="11" x2="15.5" y2="11"/>
    <line x1="11.5" y1="14" x2="15.5" y2="14"/>
  </svg>
);

const Pants = ({ size = 24, color = "currentColor" }) => (
  <svg viewBox="0 0 32 32" width={size} height={size} fill="none" stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-label="Pantaloni">
    <path d="M9 5h14l-1 22h-5l-1-14-1 14H10L9 5z" fill={color} fillOpacity="0.15"/>
    <line x1="9" y1="9" x2="23" y2="9"/>
  </svg>
);

const Jacket = ({ size = 24, color = "currentColor" }) => (
  <svg viewBox="0 0 32 32" width={size} height={size} fill="none" stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-label="Geacă">
    <path d="M12 5l-7 4 2 7 3-1v12h12V15l3 1 2-7-7-4-4 2-4-2z" fill={color} fillOpacity="0.15"/>
    <line x1="16" y1="9" x2="16" y2="27"/>
    {/* guler */}
    <path d="M13 5l3 3 3-3"/>
  </svg>
);

const Other = ({ size = 24, color = "currentColor" }) => (
  <svg viewBox="0 0 32 32" width={size} height={size} fill="none" stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-label="Altele">
    <path d="M4 11l12-5 12 5v10l-12 5-12-5V11z" fill={color} fillOpacity="0.12"/>
    <path d="M4 11l12 5 12-5M16 16v10"/>
  </svg>
);

const Helmet = ({ size = 24, color = "currentColor" }) => (
  <svg viewBox="0 0 32 32" width={size} height={size} fill="none" stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-label="Cască protecție">
    {/* dome-ul căștii — formă semi-circulară clasică */}
    <path d="M5 22c0-6.6 4.9-12 11-12s11 5.4 11 12" fill={color} fillOpacity="0.18"/>
    {/* bordura inferioară (rim) */}
    <rect x="3" y="22" width="26" height="3" rx="1" fill={color} fillOpacity="0.3"/>
    {/* nervuri verticale (creste de rigidizare) */}
    <line x1="11" y1="11" x2="11" y2="22"/>
    <line x1="16" y1="10" x2="16" y2="22"/>
    <line x1="21" y1="11" x2="21" y2="22"/>
    {/* slot ventilație frontal */}
    <ellipse cx="16" cy="12" rx="2" ry="0.8" fill={color}/>
  </svg>
);

const ICON_MAP = {
  masca: Mask,
  furtun: Hose,
  curea: Belt,
  casca: Helmet,
  cizme: Boots,
  tricou: Shirt,
  hanorac: Hoodie,
  geaca: Jacket,
  bocanci: HikingBoots,
  pantaloni: Pants,
  altele: Other,
};

/**
 * <PSACategoryIcon cat="masca" size={24} className="text-cyan-700" />
 * Folosește `className` pentru culoare (currentColor) — exact ca lucide-react.
 */
export default function PSACategoryIcon({ cat, size = 24, className = "" }) {
  const Cmp = ICON_MAP[cat] || Other;
  return (
    <span className={`inline-flex items-center justify-center ${className}`} style={{ width: size, height: size }}>
      <Cmp size={size} />
    </span>
  );
}

export { ICON_MAP };
